import { ArrowDown } from "@raresail/react-ionicons";
import styled from "styled-components";
import { PRIMARY_COLOR, PRIMARY_LIGHT } from "../../constants/colors";
import { Link } from "react-router-dom";
import { stringify } from "../../utils/helpers";

export const QuickActions = ({ actions }: { actions: any[] }) => {
  return (
    <Wrapper className="animate">
      <div className="x100 flexColumn y100 whiteBg r10 flex hidden">
        <div
          className="flexNullCenter"
          style={{
            borderBottom: `1.2px solid ${PRIMARY_LIGHT}`,
            paddingBottom: 15,
            padding: "10px 15px",
          }}
        >
          <div className="semiBold textDark flexGrow">Access Options</div>
        </div>

        <div style={{ padding: "15px 0" }}>
          <GridWrapper count={actions.length}>
            {actions.map((v, i) => (
              <div key={i}>
                <div
                  data-aos="fade-up"
                  data-aos-duration="1000"
                  data-aos-delay={i * 100}
                >
                  <OptionItem data={v} key={i} />
                </div>
              </div>
            ))}
          </GridWrapper>
        </div>
      </div>
    </Wrapper>
  );
};

export const OptionItem = ({
  data: { label, icon: Icon = ArrowDown, to, onClick },
  selected = true,
}: {
  data: any;
  selected?: boolean;
}) => {
  return (
    <Link to={to}>
      <ItemWrapper
        className="flexCenter flexColumn gap5 animate pointer"
        onClick={onClick}
      >
        <IconWrapper
          className="mainBg flexCenter white relative hidden animate"
          selected={selected}
        >
          <Icon style={{ fontSize: 22 }} />
          <div
            id="overlay"
            className={`absolute ${selected ? "whiteBg" : "mainBg"}`}
          />
        </IconWrapper>
        <div
          className={`semiBold font12 capitalize textCenter ${
            selected ? "textDark" : "main"
          }`}
        >
          {stringify(label)}
        </div>
      </ItemWrapper>
    </Link>
  );
};

const Wrapper = styled.div``;

const ItemWrapper = styled.div`
  &:hover {
    scale: 1.05;
  }
`;

const IconWrapper = styled.div<{ selected?: boolean }>`
  ${({ selected }) =>
    !selected &&
    `background-color: white;
  border: 1px solid ${PRIMARY_COLOR};
  color: ${PRIMARY_COLOR};
  `}

  border-radius: 50px;
  width: 55px;
  height: 55px;

  #overlay {
    border-radius: 50px;
    height: 80px;
    width: 80px;
    top: -50px;
    right: -30px;
    opacity: 0.1;
  }
`;

// One column per action so the row never wraps (Top Up / Withdraw / Transfer
// / Invest = 4 columns for investors, 4 for borrowers too).
// justify-items: center centers each item horizontally within its column —
// without it the Link's inline content sits flush-left and looks uneven.
const GridWrapper = styled.div<{ count: number }>`
  display: grid;
  grid-template-columns: repeat(${({ count }) => count}, 1fr);
  justify-items: center;
  gap: 16px 8px;
  padding: 0 15px;
  width: 100%;

  @media (max-width: 600px) {
    gap: 12px 4px;
    padding: 0 10px;
  }
`;